// eslint-disable
export default {
  'start': [],
  'intro': {
    'intro-bike': {
      'correct': 2,
      'question': 'What percentage of schools and colleges in Britain are located in areas with dangerously high levels of air pollution?',
      'answer': 'A scary 27% of schools are located in areas where air pollution is above guidelines recommended by the World Health Organisation – but you can help by ditching the car and travelling sustainably to school. Alternatively, you can work with your local authority to create a School Street, where no motorised traffic is allowed during school drop-off and pick-up times.',
      'options': [
        {'size': 'large', 'title': '4%'},
        {'size': 'large', 'title': '19%'},
        {'size': 'large', 'title': '27%'}
      ]
    },
    'intro-pupils': {
      'correct': 0,
      'question': 'What percentage of primary school children does the government want to be to walking to school, each day, by 2025?',
      'answer': '55%! The government’s target is 55%, but this target is a lot less than a generation ago when 70% of primary school pupils walked to school every day.',
      'options': [
        {'size': 'large', 'title': '55%'},
        {'size': 'large', 'title': '65%'},
        {'size': 'large', 'title': '70%'}
      ]
    },
    'intro-trees': {
      'correct': 2,
      'question': 'How much Carbon Dioxide do you think one, fully mature tree will absorb from the atmosphere in a year?',
      'answer': 'An amazing 22kg! However, sapling trees don’t absorb quite so much, so it’s important to look after them until they are fully matured trees!',
      'options': [
        {'size': 'large', 'title': '8kg'},
        {'size': 'large', 'title': '14kg'},
        {'size': 'large', 'title': '22kg'}
      ]
    },
    'intro-solar': {
      'correct': 1,
      'question': 'What percentage of the UK\'s energy do you think comes from renewable energy sources, like solar panels and wind turbines?',
      'answer': '39%. whilst our capacity for renewable energy is now 6x greater than 2010, we still have a long way to go to meet the Government’s aim of Net Zero by 2050.',
      'options': [
        {'size': 'large', 'title': '17%'},
        {'size': 'large', 'title': '39%'},
        {'size': 'large', 'title': '51%'}
      ]
    },
    'intro-bin': {
      'correct': 2,
      'question': 'How many phone calls do you think the RSPCA receives about animals affected by litter every day? ',
      'answer': '10! The RSPCA receives 10 calls a day about animals affected by litter… and not only does litter harm wildlife, it also costs our country hundreds of millions of pounds to clean up every year.',
      'options': [
        {'size': 'large', 'title': '1'},
        {'size': 'large', 'title': '5'},
        {'size': 'large', 'title': '10'}
      ]
    }
  },
  'school-grounds': {
    'bird-feeders': {
      'correct': 1,
      'question': 'How many pairs of native breeding birds do you think there are in the UK?',
      'answer': '83 million! There are an estimated 83 million, but this is down by 19 million since widespread monitoring began in the 1960s. This shows the importance of encouraging biodiversity and supporting animal life.',
      'options': [
        {'size': 'small', 'title': '8.3 <br> million'},
        {'size': 'small', 'title': '83 <br> million'},
        {'size': 'small', 'title': '830 <br> million'}
      ]
    },
    'polytunnel': {
      'correct': 2,
      'question': 'Transporting food is responsible for 25% of all miles covered by heavy goods vehicles (ie. lorries) in the UK. How much CO2 does transporting food around the UK produce annually?',
      'answer': '19 million tonnes! That’s the equivalent emissions of 5.5 million cars. Luckily these carbon emissions can be reduced by growing your own, shopping seasonally and locally, and of course avoiding food waste.',
      'options': [
        {'size': 'small', 'title': '900,00 <br> tonnes'},
        {'size': 'small', 'title': '9.1 <br> million <br> tonnes'},
        {'size': 'small', 'title': '19 <br> million <br> tonnes'}
      ]
    },
    'composting': {
      'correct': 0,
      'question': 'Which of these items shouldn’t be composted?',
      'answer': 'Cooked food waste! This will smell bad and attract vermin. Surprisingly you can compost teabags (providing they contain no plastic).',
      'options': [
        {'size': 'small', 'title': 'Cooked <br>food <br>waste'},
        {'size': 'small', 'title': 'Used <br> Teabags'},
        {'size': 'small', 'title': 'Fruit peel'}
      ]
    },
    'green-roof': {
      'correct': 2,
      'question': 'Green roofs can attract and support insect life. A recent survey from Kent Wildlife Trust found that between 2004 and 2022 the number of insects splats on number plates declined by how much?',
      'answer': '64%! Whilst it might seem a little strange to record the number of insect splats on number plates, it is a good way to find out about insect populations nationally.',
      'options': [
        {'size': 'large', 'title': '6%'},
        {'size': 'large', 'title': '46%'},
        {'size': 'large', 'title': '64%'}
      ]
    },
    'water-butt': {
      'correct': 2,
      'question': 'Which month is the best for collecting rainwater in the UK (during what month does it rain the most)?',
      'answer': 'December! When average rainfall is 127.27mm and it rains on average for 15 days.',
      'options': [
        {'size': 'small', 'title': 'April'},
        {'size': 'small', 'title': 'October'},
        {'size': 'small', 'title': 'December'}
      ]
    }
  },
  'classroom': {
    'computers': {
      'correct': 0,
      'question': 'What percentage of greenhouse gas emissions produced by the UK are from energy production?',
      'answer': '21%! The only sector that produces more emissions is transport, so it\'s vital that schools manage their energy use and transition to renewable sources!',
      'options': [
        {'size': 'large', 'title': '21%'},
        {'size': 'large', 'title': '31%'},
        {'size': 'large', 'title': '41%'}
      ]
    },
    'recycling-paper': {
      'correct': 2,
      'question': 'How many trees does recycling one tonne of paper save?',
      'answer': '17! It also requires 70% less energy and water to create recycled paper than it does to create new paper from trees. Are your schoolbooks made from recycled paper?  ',
      'options': [
        {'size': 'large', 'title': '1'},
        {'size': 'large', 'title': '8'},
        {'size': 'large', 'title': '17'}
      ]
    },
    'recycling-plastic': {
      'correct': 2,
      'question': 'What percentage of single-use plastics are produced from never-before-used fossil fuels?',
      'answer': '98%! Which is why the production, use, and disposal of plastics is expected to account for 19% of the global carbon budget by 2040.',
      'options': [
        {'size': 'large', 'title': '17%'},
        {'size': 'large', 'title': '54%'},
        {'size': 'large', 'title': '98%'}
      ]
    },
    'water-bottle': {
      'correct': 2,
      'question': 'What percentage of British adults do you think buy and drink a new bottle of water every day?',
      'answer': '18%! Nearly one in five adults buy and drink a new bottle of water every day. This needs to end - bottled water is 900 times more carbon intensive than tap water! Luckily the UK now has over 30,000 free-to-use refill stations and even a refill app to help people find them!',
      'options': [
        {'size': 'large', 'title': '7%'},
        {'size': 'large', 'title': '11%'},
        {'size': 'large', 'title': '18%'}
      ]
    },
    'books': {
      'correct': 1,
      'question': 'How much paper waste does the average primary school pupil produce each year?',
      'answer': '45kg! Secondary school students use less at 22kg! 45kg is the same weight as a (heavy) baby hippo!',
      'options': [
        {'size': 'small', 'title': '4kg'},
        {'size': 'small', 'title': '45kg'},
        {'size': 'small', 'title': '145kg'}
      ]
    }
  },
  'corridor': {
    'posters': {
      'correct': 2,
      'question': 'How much plastic do you think reaches oceans each year, harming marine life?',
      'answer': '8 million tonnes! This is the equivalent of placing five bags full of rubbish on every foot of coastline around the world!',
      'options': [
        {'size': 'small', 'title': '80,000 <br>tonnes'},
        {'size': 'small', 'title': '800,000<br>tonnes'},
        {'size': 'small', 'title': '8 million<br>tonnes'}
      ]
    },
    'lights': {
      'correct': 1,
      'question': 'What percentage of a school’s energy use do you think lighting accounts for?',
      'answer': '8%! Only heating classrooms and water uses more energy in a school.',
      'options': [
        {'size': 'large', 'title': '2%'},
        {'size': 'large', 'title': '8%'},
        {'size': 'large', 'title': '19%'}
      ]
    },
    'noticeboard': {
      'correct': 0,
      'question': 'What uses the most energy in a school?',
      'answer': 'Heating! Space heating accounts for 58% (more than half!) of a school’s energy use, but simple measures like draft proofing, ensuring radiators aren’t blocked, and using communal entrances can save up to 30% of heating costs.',
      'options': [
        {'size': 'small', 'title': 'Heating'},
        {'size': 'small', 'title': 'food and drink prep'},
        {'size': 'small', 'title': 'Powering devices'}
      ]
    },
    'crisp-bin': {
      'correct': 1,
      'question': 'How many packets of crisps do you think we eat in the UK every year?',
      'answer': '6 billion! That’s 100 packets per person every year - schools can make a huge difference by collecting crisp packets for recycling.',
      'options': [
        {'size': 'small', 'title': '900<br>million'},
        {'size': 'small', 'title': '6<br>billion'},
        {'size': 'small', 'title': '8<br>billion'}
      ]
    },
    'litter-pickers': {
      'correct': 0,
      'question': 'What do you think is the most commonly littered item that pupils will find whilst litter-picking?',
      'answer': 'Cigarette butts! This is bad because they’re made of plastic, take up to 14 years to decompose, can easily make their way to marine environments, they are also tricky to pick up with litter-pickers!',
      'options': [
        {'size': 'small', 'title': 'Cigarette<br> butts'},
        {'size': 'small', 'title': 'Chocolate<br>bar wrappers'},
        {'size': 'small', 'title': 'Drinks bottles and cans'}
      ]
    }
  },
  'bathroom': {
    'cistern': {
      'correct': 2,
      'question': 'How much water do you think an old-style toilet uses each time it is flushed?',
      'answer': '13 litres! This school’s simple water-saving devices will make a huge difference. Modern dual flush systems only use between 4 – 6 litres per flush.',
      'options': [
        {'size': 'small', 'title': '4 litres'},
        {'size': 'small', 'title': '6 litres'},
        {'size': 'small', 'title': '13 litres'}
      ]
    },
    'toilet': {
      'correct': 2,
      'question': 'In 2019 Thames 21 organised a two-hour volunteer clean up on the shore of the Thames River in Barnes Southwest London. How many wet wipes did they find?',
      'answer': '23,000! Wet wipes do not break down like toilet paper and contribute to more than 90% of sewer blockages in the UK. They can also devastate wildlife when they eventually enter our rivers and oceans… remember to only flush the three p’s!',
      'options': [
        {'size': 'small', 'title': '1,700'},
        {'size': 'small', 'title': '11,600'},
        {'size': 'small', 'title': '23,000'}
      ]
    },
    'hand-dryer': {
      'correct': 2,
      'question': 'Paper towels generate more emissions than the most efficient hand dryers, but how much more?',
      'answer': 'Up to 70% more! This figure takes into account all aspects of the manufacturing process including mining the ore to produce metal hand dryers!',
      'options': [
        {'size': 'small', 'title': 'Up to 5% more'},
        {'size': 'small', 'title': 'Up to 40% more'},
        {'size': 'small', 'title': 'Up to 70% more'}
      ]
    },
    'hand-soap': {
      'correct': 2,
      'question': 'How long do you think it takes a single-use, plastic bottle to decompose?',
      'answer': '450 years! That’s a very long time for something that will be used for just a few weeks before being discarded!',
      'options': [
        {'size': 'small', 'title': '4 years'},
        {'size': 'small', 'title': '45 years'},
        {'size': 'small', 'title': '450 years'}
      ]
    },
    'sensor-taps': {
      'correct': 1,
      'question': 'How many litres of water would a tap waste in 1 minute if it was left on by mistake?',
      'answer': '6! It would waste six litres per minute! That’s approximately the same as 24 full, average sized glasses!',
      'options': [
        {'size': 'large', 'title': '3'},
        {'size': 'large', 'title': '6'},
        {'size': 'large', 'title': '9'}
      ]
    }
  },
  'canteen': {
    'meals': {
      'correct': 0,
      'question': 'Which of these foods has the largest Carbon Footprint?',
      'answer': 'Beef! Beef produces 60kg of CO2e for every 1kg of food, and nuts only create around 0.5kg of C02e for every kg! One of the reasons beef is responsible for so much CO2e is because cows produce a lot of methane, a greenhouse gas more potent than CO2.',
      'options': [
        {'size': 'small', 'title': 'Beef'},
        {'size': 'small', 'title': 'Fish'},
        {'size': 'small', 'title': 'Potatoes'}
      ]
    },
    'staff': {
      'correct': 1,
      'question': 'How much food is wasted in the UK every year?',
      'answer': '6.6 million tonnes! This wasted food is responsible for nearly 25 million tonnes of CO2 emissions annually and could be used to make over 15 billion meals, enough to feed everyone in the UK 3 meals a day for 11 weeks!',
      'options': [
        {'size': 'small', 'title': '3.1<br>million tonnes'},
        {'size': 'small', 'title': '6.6<br>million tonnes'},
        {'size': 'small', 'title': '9.5<br>million tonnes'}
      ]
    },
    'fairtrade-food': {
      'correct': 1,
      'question': 'How many farmers and workers are in Fairtrade certified organisations around the world?',
      'answer': '1.9 million! This is great because Fairtrade certification not only sets high standards for workers, it also sets strict environmental standards that certified producers must follow.',
      'options': [
        {'size': 'small', 'title': '1.4<br>million'},
        {'size': 'small', 'title': '1.9<br>million'},
        {'size': 'small', 'title': '2.1<br>million'}
      ]
    },
    'cups-plates': {
      'correct': 0,
      'question': 'On 27th December 2019, the government’s education secretary challenged each school to become single-use-plastic-free by when?',
      'answer': '2022! Did your school manage it? If not It’s never too late to go single-use-plastic-free!',
      'options': [
        {'size': 'large', 'title': '2022'},
        {'size': 'large', 'title': '2025'},
        {'size': 'large', 'title': '2030'}
      ]
    },
    'recycling-bins': {
      'correct': 0,
      'question': 'How much of England and Wales’ waste cannot be recycled due to recycling contamination?',
      'answer': '17%! this shows how important it is that people understand what belongs in each bin and how to pre-cycle items (prepare an item for recycling).',
      'options': [
        {'size': 'large', 'title': '17%'},
        {'size': 'large', 'title': '27%'},
        {'size': 'large', 'title': '37%'}
      ]
    }
  }
}
// eslint-enable



// WEBPACK FOOTER //
// ./src/scoreData.js